import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { Box, Grid, Stack, Divider, Typography } from '@mui/material';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function HomeFooter() {
  const theme = useTheme();

  return (
    <Container maxWidth="xl" sx={{ pt: 10 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={5}>
          <Stack direction="column" spacing={2} sx={{ alignItems: 'flex-start', pb: 2 }}>
            <Typography variant="h4" sx={{ color: '#FF9900', fontWeight: 800 }}>
              CÔNG TY TNHH NHÀ SÁCH - THIẾT BỊ ÁNH DƯƠNG
            </Typography>
            <Typography variant="body2" sx={{ pr: 4 }}>
              <strong>CÔNG TY TNHH NHÀ SÁCH – THIẾT BỊ ÁNH DƯƠNG </strong>là đơn vị chuyên cung cấp
              sách giáo dục, thiết bị dạy học, đồ dùng học tập và các giải pháp hỗ trợ trường học.
              Với sứ mệnh đồng hành cùng ngành giáo dục Việt Nam, chúng tôi mang đến những sản phẩm
              chính hãng, chất lượng, an toàn, đáp ứng đầy đủ nhu cầu của trường học, giáo viên và
              học sinh.
            </Typography>
            <Typography variant="h6">Kết nối với chúng tôi</Typography>
            <Box sx={{ gap: 2, display: 'flex', flexWrap: 'wrap' }}>
              <a href="https://zalo.me/yourid" target="_blank" rel="noopener noreferrer">
                <Iconify width={32} icon={'simple-icons:zalo' as any} color="blue" />
              </a>
              <a href="mailto:example@mail.com">
                <Iconify width={32} icon={'streamline-stickies-color:mail' as any} />
              </a>
              <a
                href="https://www.facebook.com/yourprofile"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Iconify width={32} icon={'logos:facebook' as any} />
              </a>
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Stack direction="column" spacing={2} sx={{ alignItems: 'flex-start', pb: 2 }}>
            <Typography variant="h4" sx={{ color: '#FF9900', fontWeight: 600 }}>
              THÔNG TIN LIÊN HỆ
            </Typography>
          </Stack>
          <Stack direction="column" spacing={2} sx={{ alignItems: 'flex-start' }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Iconify
                icon={'streamline-stickies-color:mail' as any}
                width={28}
                aria-hidden="true"
              />
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2">Email</Typography>
                <Typography variant="body2" sx={{ color: 'blue', textDecoration: 'underline' }}>
                  thietbinhasachanhduong@gmail.com
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <Iconify
                icon={'streamline-flex-color:call-center-support-service' as any}
                width={32}
                aria-hidden="true"
              />
              <Typography variant="body2">Hotline: 0762 961 199 (Khánh)</Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <Iconify
                icon={'openmoji:location-indicator-red' as any}
                width={36}
                aria-hidden="true"
              />
              <Typography variant="body2">
                Địa chỉ: 70 Hoàng Quốc Việt, Phường An Bình, Thành phố Cần Thơ
              </Typography>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Stack direction="column" spacing={2} sx={{ alignItems: 'flex-start', pb: 2 }}>
            <Typography variant="h4" sx={{ color: '#FF9900', fontWeight: 800 }}>
              KẾT NỐI VỚI CHÚNG TÔI
            </Typography>

            <Box
              sx={{
                width: '100%',
                height: 200,
                overflow: 'hidden',
                borderRadius: 2,
                border: '2px solid #ecb858ff',
              }}
            >
              <iframe
                title="Bản đồ Anh Dương Book Equipment"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11328.510616615386!2d105.7390540247887!3d10.032523147358381!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a0899d8df5048d%3A0x37bb5987773fd890!2zTkjDgCBTw4FDSCDDgU5IIETGr8agTkc!5e0!3m2!1svi!2s!4v1767861047947!5m2!1svi!2s"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </Box>
          </Stack>
        </Grid>
      </Grid>
      <Divider sx={{ borderWidth: 1.5, borderColor: '#FF9900', mt: 2 }} />
    </Container>
  );
}
